import { render, staticRenderFns } from "./AlertToggle.vue?vue&type=template&id=5efea4ce"
import script from "./AlertToggle.vue?vue&type=script&lang=js"
export * from "./AlertToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports